var module = angular.module('octopusApp.configuration');

module.controller('CreateApiKeyDialogController', function ($scope, busy, octopusRepository, user, $uibModalInstance) {
  var isWorking = $scope.isWorking = busy.create();
  $scope.user = user;
  $scope.createParams = { purpose: '' };

  $scope.close = function() {
    $uibModalInstance.close(true);
  };

  $scope.cancel = function() {
    $uibModalInstance.close();
  };

  $scope.execute = function() {
    isWorking.promise(octopusRepository.Users.createApiKey($scope.user, $scope.createParams.purpose).then(function(apiKey) {
      $scope.apiKey = apiKey;
    }));
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/users/controllers/create_api_key_dialog_controller.js
// module id = 407
// module chunks = 1